<template>
  <form action="/api/quotation" id="form_car" method="POST" ref="formCar" @submit="handleSubmit">
    <input type="hidden" name="quotation_id" :value="quotationId" />
    <input type="hidden" name="quotation_type" :value="currentQuotationType" />

    <bike-recap :infobike="infobike" :quotationType="quotationType"></bike-recap>

    <form-fields
      :type="quotationType"
      :km="standardKm"
      :km_placeholder="km_placeholder"
      :kmMensili="kmMensili"
      :cap="cap"
      :liveMarketExists="liveMarketExists"
      :notes="notes"
      :anni="anni"
      :mesi="mesi"
      @date-validation="updateDateValidation"
    ></form-fields>

    <buy-quotation-btn
      :type="quotationType"
      :loading="loading"
      @submit-form="onSubmitForm"
      @updateLoading="updateLoading"
      :promotions="promotions"
      :acquisto-cta="acquistoCta"
      :liveMarketExists="liveMarketExists"
      :is-date-valid="isDateValid"
    ></buy-quotation-btn>
  </form>
</template>

<script>
import BikeRecap from './BikeRecap.vue';
import FormFields from './FormFields.vue';
import BuyQuotationBtn from './BuyQuotationBtn.vue';

export default {
  name: 'BuyQuotationForm',
  components: {
    BikeRecap,
    FormFields,
    BuyQuotationBtn,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    quotationType: {
      type: String,
      required: true,
    },
    promotions: {
      type: Object,
      required: false,
    },
    acquistoCta: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    liveMarketExists: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      kmValue: this.data.km,
      currentQuotationType: this.quotationType,
      isDateValid: false,
    };
  },
  computed: {
    infobike() {
      return this.data.infobike;
    },
    standardKm() {
      const km = Number(this.data.km);
      if (km > 0) {
        return km;
      }
      const kmDefault = Number(this.data.km_default);
      return kmDefault > 0 ? kmDefault : 0;
    },
    km() {
      return this.standardKm;
    },
    km_placeholder() {
      return this.data.km_placeholder || '';
    },
    kmMensili() {
      const raw =
        this.data.km_mensili != null ? this.data.km_mensili : this.data.kmMensili;
      return raw != null && raw !== '' ? Number(raw) : null;
    },
    cap() {
      return this.data.cap || '';
    },
    notes() {
      return this.data.notes;
    },
    quotationId() {
      return this.data.quotation_id;
    },
    anni() {
      return this.data.tendina_annomese.anno;
    },
    mesi() {
      return this.data.tendina_annomese.mese;
    },
  },
  methods: {
    updateDateValidation(isValid) {
      this.isDateValid = isValid;
    },
    updateLoading(isLoading) {
      this.loading = isLoading;
    },
    onSubmitForm(newType) {
      this.currentQuotationType = newType;
      this.$nextTick(() => {
        this.$refs.formCar.submit();
      });
    },
    handleSubmit() {
      this.loading = true;
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/app/components/BuyQuotationForm.vue